import { HttpErrorResponse } from '@angular/common/http';
import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';
import {
    GetTemplatesNamesAndIdsDto,
    GetTranslationsDto,
    IGroupEntityDTO,
    ITemplateEntityDTO,
    TemplateType,
    UpdateTranslationsDto,
} from '@modeso/types__aumico-lib-templates-be';
import { Action, createAction, createActionGroup, props } from '@ngrx/store';
import { IFinancialLineItem } from '../interfaces/settings.interface';
import { TemplatesTranslationRequest } from '../interfaces/templates-translation-request.interface';
import { TemplatesTranslationResponse } from '../interfaces/templates-translation-response.interface';

//Groups
export const getGroups = createAction('[Aumico-Templates] getGroups');

export const onGetGroupsSuccessfully = createAction(
    '[Aumico-Templates] onGetGroupsSuccessfully',
    props<{ payload: Array<IGroupEntityDTO> }>(),
);

export const onGetGroupsFailed = createAction(
    '[Aumico-Templates] onGetGroupsFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const setActiveGroup = createAction('[Aumico-Templates] setActiveGroup', props<{ payload: string }>());

export const removeActiveGroup = createAction('[Aumico-Templates] removeActiveGroup');

export const createGroup = createAction('[Aumico-Templates] createGroup', props<{ group: IGroupEntityDTO }>());

export const onCreateGroupSuccessfully = createAction(
    '[Aumico-Templates] onCreateGroupSuccessfully',
    props<{ payload: IGroupEntityDTO }>(),
);

export const onCreateGroupFailed = createAction(
    '[Aumico-Templates] onCreateGroupFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const updateGroup = createAction(
    '[Aumico-Templates] updateGroup',
    props<{ group: IGroupEntityDTO; groupId: string }>(),
);

export const onUpdateGroupSuccessfully = createAction(
    '[Aumico-Templates] onUpdateGroupSuccessfully',
    props<{ payload: IGroupEntityDTO }>(),
);

export const onUpdateGroupFailed = createAction(
    '[Aumico-Templates] onUpdateGroupFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const deleteGroup = createAction('[Aumico-Templates] deleteGroup', props<{ payload: string }>());

export const onDeleteGroupSuccessfully = createAction(
    '[Aumico-Templates] onDeleteGroupSuccessfully',
    props<{ payload: string }>(),
);

export const onDeleteGroupFailed = createAction(
    '[Aumico-Templates] onDeleteGroupFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const getTranslations = createAction(
    '[Aumico-Templates] translationsActions.getAllCurrency',
    props<{ locales: string[]; untranslatedOnly: boolean }>(),
);
export const onGetTranslationsSuccess = createAction(
    '[Aumico-Templates] translationsActions.onGetTranslationsSuccess',
    props<{ payload: GetTranslationsDto }>(),
);
export const onGetTranslationsFailed = createAction(
    '[Aumico-Templates] translationsActions.onGetTranslationsFailed',
    props<{ payload: HttpErrorResponse }>(),
);
export const updateTranslations = createAction(
    '[Aumico-Templates] translationsActions.updateTranslations',
    props<{ payload: UpdateTranslationsDto }>(),
);
export const onUpdateTranslationsSuccess = createAction(
    '[Aumico-Templates] translationsActions.onUpdateTranslationsSuccess',
);
export const onUpdateTranslationsFailed = createAction(
    '[Aumico-Templates] translationsActions.onUpdateTranslationsFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const selectGroups = createAction('[Aumico-Templates] selectGroups', props<{ payload: string[] }>());

export const deselectGroup = createAction('[Aumico-Templates] deselectGroup', props<{ payload: string }>());

export const removeGroupsResponse = createAction('[Aumico-Templates] removeGroupsResponse');

export const removeGroupsError = createAction('[Aumico-Templates] removeGroupsError');

//Templates
export const getTemplates = createAction('[Aumico-Templates] getTemplates');

export const onGetTemplatesSuccessfully = createAction(
    '[Aumico-Templates] onGetTemplatesSuccessfully',
    props<{ payload: Array<ITemplateEntityDTO> }>(),
);

export const onGetTemplatesFailed = createAction(
    '[Aumico-Templates] onGetTemplatesFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const getTemplateByLegalFormAndAccountBasis = createAction(
    '[Aumico-Templates] getTemplateByLegalFormAndAccountBasis',
    props<{ templateType: string; legalForm: string; accountBasis: string }>(),
);

export const onGetTemplateByLegalFormAndAccountBasisSuccessfully = createAction(
    '[Aumico-Templates] onGetTemplateByLegalFormAndAccountBasisSuccessfully',
    props<{ payload: ITemplateEntityDTO }>(),
);

export const onGetTemplateByLegalFormAndAccountBasisFailed = createAction(
    '[Aumico-Templates] onGetTemplateByLegalFormAndAccountBasisFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const getTemplateById = createActionGroup({
    source: '[Aumico-Templates] getTemplateById',
    events: {
        do: props<{ payload: string }>(),
        success: props<{ payload: ITemplateEntityDTO }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const resetTemplateByLegalFormAndAccountBasis = createAction(
    '[Aumico-Templates] resetTemplateByLegalFormAndAccountBasis',
);

export const setActiveTemplate = createAction('[Aumico-Templates] setActiveTemplate', props<{ payload: string }>());

export const setActiveTemplateType = createAction(
    '[Aumico-Templates] setActiveTemplateType',
    props<{ payload: TemplateType }>(),
);

export const removeActiveTemplate = createAction('[Aumico-Templates] removeActiveTemplate');

export const createTemplate = createAction(
    '[Aumico-Templates] createTemplate',
    props<{ template: ITemplateEntityDTO }>(),
);

export const onCreateTemplateSuccessfully = createAction(
    '[Aumico-Templates] onCreateTemplateSuccessfully',
    props<{ payload: ITemplateEntityDTO }>(),
);

export const onCreateTemplateFailed = createAction(
    '[Aumico-Templates] onCreateTemplateFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const updateTemplate = createAction(
    '[Aumico-Templates] updateTemplate',
    props<{ template: ITemplateEntityDTO; templateId: string }>(),
);

export const onUpdateTemplateSuccessfully = createAction(
    '[Aumico-Templates] onUpdateTemplateSuccessfully',
    props<{ payload: ITemplateEntityDTO }>(),
);

export const onUpdateTemplateFailed = createAction(
    '[Aumico-Templates] onUpdateTemplateFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const getTemplatesTargetTranslations = createActionGroup({
    source: '[Aumico-Templates] getTemplatesTargetTranslations',
    events: {
        do: props<{ payload: TemplatesTranslationRequest }>(),
        success: props<{ payload: TemplatesTranslationResponse }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const removeTemplatesResponse = createAction('[Aumico-Templates] removeTemplatesResponse');

export const removeTemplatesError = createAction('[Aumico-Templates] removeTemplatesError');

export const setSubtotalsNames = createAction('[Aumico-Templates] setSubtotalsNames', props<{ payload: string[] }>());

export const removeSubtotalName = createAction('[Aumico-Templates] removeSubtotalName', props<{ payload: string }>());

export const setFinancialLineItems = createAction(
    '[Aumico-Templates] setFinancialLineItems',
    props<{ payload: IFinancialLineItem[] }>(),
);

export const selectFinancialLineItems = createAction(
    '[Aumico-Templates] selectFinancialLineItems',
    props<{ payload: string[] }>(),
);

export const deselectFinancialLineItem = createAction(
    '[Aumico-Templates] deselectFinancialLineItem',
    props<{ payload: string }>(),
);

export const getAllTemplatesNamesAndIdsByTemplateType = createActionGroup({
    source: '[Aumico-Templates] Get All Templates Names And Ids By Template Type',
    events: {
        'Get All Templates Names And Ids By Template Type': props<{
            payload: TemplateType;
        }>(),
        'Get All Templates Names And Ids By Template Type Success': props<{ payload: GetTemplatesNamesAndIdsDto[] }>(),
        'Get All Templates Names And Ids By Template Type Failed': props<{ payload: HttpErrorResponse }>(),
    },
});

export const allAccounts = createActionGroup({
    source: '[Aumico-Templates] all accounts',
    events: {
        set: props<{ payload: IAccount[] }>(),
        addAccount: props<{ payload: IAccount }>(),
        'update account': props<{ payload: { updatedAccount: IAccount; oldAccountNumber: string } }>(),
    },
});
export interface ActionWithPayload<T> extends Action {
    payload: T;
}
